export default "__VITE_ASSET__Cl$IH7uo__"